import wx from 'weixin-js-sdk';
import { getSignature } from '@/api/wechat/index'
import { uploadImage } from '@/views/index/api/'
import { showMessage } from './message'
var voiceAttachData = {}

const jsSdk = {
  async init (jsApiList = ['getLocation','hideMenuItems','previewImage','chooseImage','uploadImage', 'startRecord','stopRecord','uploadVoice', 'onMenuShareAppMessage', 'onMenuShareTimeline'], debug = false) {
    let url = ''
    if (window.__wxjs_is_wkwebview === true) {
      url = window.IOSURL.split('#')[0]
    } else {
      url = window.location.href.split('#')[0]
    }

    let lastUrl = sessionStorage.getItem('lastUrl')
    if (lastUrl === url) {
      return 1
    }

    let res = await getSignature({
      url: url
    })

    let that = this

    return new Promise((resolve, reject)=>{
      wx.config({
        debug: debug, // 开启调试模式,
        appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名，见附录1
        jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })

      wx.ready((res) => {
        sessionStorage.setItem('lastUrl', url)
        resolve(1)
      })

      wx.error((res) => {
        console.log('签名错误')
        console.log(res)
        resolve(0)
      })
    })
  },
  setShareData (shareData, cb) {
    // 朋友或qq
    
    wx.onMenuShareAppMessage({
      title: shareData.title || '', // 分享标题
      desc: shareData.description || '', // 分享描述
      link: shareData.url || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.coverUrl || '', // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户点击了分享后执行的回调函数
        console.log('朋友')
        cb && cb()
      }
    })
    // 朋友圈或QQ空间
    wx.onMenuShareTimeline({
      title: shareData.title || '', // 分享标题
      link: shareData.url || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.coverUrl || '', // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
        console.log('朋友圈')
        cb && cb()
      }
    })
  },
  // 上传照片(微信)
  chooseImage(count) {
    return new Promise((resolve, reject)=>{
      let  that = this;
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["camera","album"], // 可以指定来源是相册还是相机，默认二者都有
        async success(res) {
          if (!res.localIds.length) {
            resolve(null)
          }
          let imgData = await that.uploadImg(res.localIds[0]);
          resolve(imgData)
        },
        fail() {
          showMessage("请重新选择图片！");
        }
      })
    })
  },
  uploadImg(localId) {
    let _this = this
    return new Promise((resolve, reject)=>{
      let that = _this;
      wx.uploadImage({
        localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
        async success(res) {
          var serverId = res.serverId; // 返回图片的服务器端ID
          let imgData = await that.uploadApi(serverId);
          resolve(imgData)
        }
      });
    })
  },
  async uploadApi(serverId) {
    let res = await uploadImage({
      mediaId: serverId
    });
    let imgData = res.data;
    return imgData
  },
  async scanCode () {
    new Promise((resolve, rejected) => {
      wx.scanCode({
        onlyFromCamera: true,
        success (res) {
          if (res.path) {
            resolve(res.path)
          } else {
            rejected()
          }
        }
      })
    })
  },
  // 开始录音
  starRecord () {
    let that = this
    voiceAttachData = {}
    return new Promise((resolve, rejected) => {
      wx.startRecord({
        success (res) {
          const tempFilePath = res.tempFilePath
          // 是否有过录音授权
          if (!localStorage.getItem('selectCategoryData')) {
            localStorage.setItem('recordAuth', 'isAuth')
            wx.stopRecord()
            rejected()
          } else {
            resolve(1)
            wx.onVoiceRecordEnd({
              // 录音时间超过一分钟没有停止的时候会执行 complete 回调
              complete: async (res) => {
                console.log('最多只能录制一分钟');
                var localId = res.localId;
                voiceAttachData =  await that.uploadVoice(localId)
              }
            });
          }
        }
      })
    })
  },
  // 结束录音
  stopRecord () {
    let that = this
    return new Promise((resolve, rejected) => {
      wx.stopRecord({
        success: async (res) => {
          var localId = res.localId;
          let voiceData =  await that.uploadVoice(localId)
          resolve(voiceData)
        }
      });
    })

  },
  // 上传录音
  uploadVoice (localId) {
    let that = this
    return new Promise((resolve, reject)=>{
      if (!voiceAttachData.fileKey) {

        wx.uploadVoice({
          localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
          success: async (res) => {
            var serverId = res.serverId; // 返回音频的服务器端ID
            let voiceData = await that.uploadApi(serverId)
            let attachData = {
              fileKey: voiceData.key,
              filePath: voiceData.url,
              fileType: 'audio'
            }
            resolve(attachData)
          },
          fail (res) {
            console.log('uploadVoice===>fail',res)
          }
        });
      } else {
        resolve(voiceAttachData)
      }
    });
  },
  // 预览图片接口
  previewImage (index,imgUrl = []) {
    wx.previewImage({
      current: imgUrl[index], // 当前显示图片的http链接
      urls: imgUrl // 需要预览的图片http链接列表
    });
  },
  // 定位
  getLocation () {
    return new Promise((resolve, reject)=>{
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success (res) {
          let obj = {
            lng: res.longitude,
            lat: res.latitude
          }

          var x_PI = 3.14159265358979324 * 3000.0 / 180.0;

          // * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
          var z = Math.sqrt(obj.lng * obj.lng + obj.lat * obj.lat) + 0.00002 * Math.sin(obj.lat * x_PI);
          var theta = Math.atan2(obj.lat, obj.lng) + 0.000003 * Math.cos(obj.lng * x_PI);
          var bd_lng = z * Math.cos(theta) + 0.0065;
          var bd_lat = z * Math.sin(theta) + 0.006;

          obj = {
            lng: bd_lng,
            lat: bd_lat,
          }
          resolve(obj);
        },
        fail () {
          resolve(0);
        }
      })
    })
  }
}

export default jsSdk
